export default "__VITE_ASSET__DBdwzi09__"